/**
 *
 * API sync middleware
 *
 * This middleware listens to API-related actions and sends invalidation messages over the Ably channel to ensure all clients have the same representation of remote data.
 */
import { createListenerMiddleware } from '@reduxjs/toolkit'
import { ABLY_MESSAGES } from '~/lib/constants'
import socket from '~/lib/socket'

const logger = console.scope('apiSync')

import { TAGS } from '~/store/api/base'

// Create the middleware
const apiSync = createListenerMiddleware()

// Start listening to API actions
apiSync.startListening({
	matcher: action => {
		// Check if this is a fulfilled API mutation action
		return (
			action.type === 'api/executeMutation/fulfilled' &&
			action.meta?.arg?.endpointName &&
			action.meta?.arg?.type === 'mutation'
		)
	},
	effect: async (action, { getState }) => {
		// Get the endpoint name from the action meta
		const endpointName = action.meta.arg.endpointName

		// Determine which tags to invalidate based on the endpoint name
		const tags = []

		// Preset-related actions
		if (
			endpointName === 'addPreset' ||
			endpointName === 'updatePreset' ||
			endpointName === 'deletePresets' ||
			endpointName === 'updateProject'
		) {
			// Get the project ID from the action payload or state
			const projectId = action.payload?.projectId || getState().app.project_id
			if (projectId) {
				// Invalidate ONLY the project tag.
				tags.push({ type: TAGS.PROJECT, id: projectId })
			} else {
				logger.warn('Preset action detected, but no project ID found to invalidate tags.')
			}
		}

		// Session-related actions
		if (endpointName === 'startSession' || endpointName === 'stopSession') {
			tags.push({ type: TAGS.SESSION, id: 'LIST' })
			tags.push({ type: TAGS.SESSION, id: 'active' }) // Invalidate getActiveSession on other clients
		}

		// Recording-related actions
		/* if (
			endpointName === 'startRecording' ||
			endpointName === 'stopRecording' ||
			endpointName === 'patchRecording' ||
			endpointName === 'deleteRecording'
		) {
			tags.push({ type: 'Recording', id: 'LIST' })

			// If it's a specific recording, also invalidate that recording's tag
			if (action.payload?.id) {
				tags.push({ type: 'Recording', id: action.payload.id })
			}
		} */

		// If we have tags to invalidate, send the message over the Ably channel
		if (tags.length > 0) {
			socket.sendToUser(ABLY_MESSAGES.INVALIDATE_API_TAGS, tags)
		}
	},
})

export default apiSync
